import React from 'react';

const startOver = (props) => {
  return (
    <section className={'modal startOver show'}>
      <div id='overlayBG' onClick={props.closeModal}>
        <div id='overlay' onClick={(event) => { event.stopPropagation(); }}>
          <div className='wrap sm text-center'>
            <button className='close' onClick={props.closeModal}>Close</button>
            <h4>Want to start over?</h4>
            <p>This will clear your answers and start again from the beginning.</p>
            <button className='btn grey' onClick={props.closeModal}>Cancel</button>
            <button className='btn' onClick={props.startOver}>Start Over</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default startOver;



// WEBPACK FOOTER //
// ./src/components/Header/StartOver.jsx